import { firstValueFrom } from 'rxjs';
import { Directive, Input, Output, EventEmitter, HostListener } from '@angular/core';;
import { NowcertsService } from '../service/nowcerts.service';
import { AddPolicyService } from 'app/main/popups/add-policy/add-policy.service';
import * as config from 'app/app.config';
import * as handlingStorage from "app/handling-storage";

@Directive({
  selector: '[app-sync-policy-nowcerts]'
})
export class SyncPolicyNowcertsDirective {

  @Input() policy;
  @Output() policySyncComplete = new EventEmitter()

  loading = false;

  @HostListener('click', ['$event']) onClick($event) {
    // *(this.addPolicyService.getSyncPolicy());
    if(this.addPolicyService.getSyncPolicy()){
      this.policy = this.addPolicyService.getSyncPolicy()
    }
    
    if(!this.policy || !this.policy._id){
      // *('policy: ', this.policy);      
      console.error('no policy found');
      return;
    }

    let pagent = handlingStorage.getParentAgent()
    let payload = {
      _id: this.policy._id,
      // policy_id: this.policy._id,
      // agency_id: pagent.agency_id._id,
    }
    this.syncPolicy(payload)
  }
  constructor(
    private nowcertsService: NowcertsService,
    private addPolicyService: AddPolicyService,
  ) { }

  private async syncPolicy(payload) {
    try {
      this.loading = true;
      this.policySyncComplete.next({loading:this.loading})
      let res = await firstValueFrom(this.nowcertsService.syncPolicy(payload))
      // console.log("syncPolicy", res)
      this.loading = false;
      this.policySyncComplete.next({loading:this.loading, success:true, res})
    } 
    catch (err) {
      this.loading = false;
      this.policySyncComplete.next({loading:this.loading, success:false, error: err})
    }
  }

}
